var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTshirtIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.766 9.5l-2.344-1.453c-.047 0-.14-.047-.235-.047h-2.343c-.282 0-.469.188-.469.469a1.88 1.88 0 01-1.875 1.875 1.88 1.88 0 01-1.875-1.875c0-.281-.188-.469-.469-.469H9.812c-.093 0-.187.047-.234.047L7.234 9.5A.492.492 0 007 9.922v3.703c0 .281.188.469.469.469h1.875v7.5c0 .281.187.468.469.468h9.374c.282 0 .47-.187.47-.468v-7.5h1.874c.282 0 .469-.188.469-.469V9.922a.492.492 0 00-.234-.422z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirtIcon);
export default __webpack_public_path__ + "static/media/tshirtIcon.61ce493d.svg";
export { ForwardRef as ReactComponent };